<template>
  <div class="swiper-container">
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="(item,index) in data" :key="index">
        <img :src="item.carouselImg" class="imagecover" />
      </swiper-slide>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      swiperOption: {
        direction: 'horizontal',
        autoplayDisableOnInteraction: false,
        autoplayStopOnLast: false,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        speed: 500,
        initialSlide: 0,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
      },
    };
  },
  mounted() {
    console.log(this.data);
  }
};
</script>

<style lang="scss" scoped>
.swiper-container {
  width: 100%;
  height: 800px;
  position: relative;
  overflow: hidden;
  .swiper-button-prev {
    width: 40px;
    height: 40px;
    left: 40px;
    background-image: url(../../../assets/images/arrow-left.png);
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: center;
    background-color: rgba(0, 0, 0, .1);
    cursor: pointer;
    &:hover {
      background-color: rgba(0, 0, 0, .3);
    }
  }
  .swiper-button-next {
    width: 40px;
    height: 40px;
    right: 40px;
    background-image: url(../../../assets/images/arrow-right.png);
    background-size: 20px 20px;
    background-repeat: no-repeat;
    background-position: center;
    background-color: rgba(0, 0, 0, .1);
    cursor: pointer;
    &:hover {
      background-color: rgba(0, 0, 0, .3);
    }
  }
}
</style>